<template>
    <div class="page-container">
        <div class="section" v-if="role == 'partner' && userInfo.level == 2">
            <div class="section-title">一、初级合伙人政策</div>
            <div class="section-content">1、加入门槛：一次性订货不低于4.2万元商品；</div>
            <div class="section-content">2、可享受初级合伙人级别进货价；</div>
            <div class="section-content">
                3、可享受进货同品类商品的优惠政策如下: <br>
                ① 御粮春生、御粮夏长进货满5*n箱赠送3*n箱奖励2*n箱(n为整数)<br>
                ② 御粮秋实、御粮冬藏每进货n箱赠送n箱.<br>
                (以此类推,上不封顶)
            </div>
            <div class="section-content">4、每次进货订单中的赠送商品随进货商品一同发放，该订单中的奖励商品在下次补货时(即下次补款时)发放至销售奖励账户；</div>
            <div class="section-content">5、订货的商品可分批次进货，每次进货数量须为5箱或5箱的倍数；奖励商品可分批次整箱提货；</div>
            <div class="section-content">6、可任品类搭配商品，但需满足同品类5箱或5箱的倍数进货；</div>
            <div class="section-content">7、无需交纳保证金；</div>
            <div class="section-content">8、不可低于公司线下最低指导价进行销售，乱价合伙人不享受公司额外奖励的商品；</div>
            <div class="section-content">9、可不定期参加公司组织的销售培训；</div>
            <div class="section-content">10、公司为合伙人开展线下商品品鉴活动提供津贴支持。品鉴活动参加人数原则上不得低于20人/场，每位合伙人每月仅可申请一次津贴支持。公司对满足条件的品鉴活动提供如下支持：</div>
            <div class="section-content">（1）组织活动的合伙人可向公司申请津贴，津贴标准为120元/人。申请批准后，津贴将于品鉴活动结束次月10日前发放至合伙人推荐奖账户（合伙人推荐奖账户定义、使用方法参见公司另行制定的《合伙人账户使用说明》）；</div>
            <div class="section-content">（2）公司免费提供御粮春生酒供参会人员品鉴，提供标准为：每10人提供2瓶；</div>
            <div class="section-content">（3）公司将派遣工作人员前往品鉴活动现场配合合伙人进行御粮产品宣讲与推广；</div>
            <div class="section-content">11、年终按照总销售额排名享受公司各项奖励；</div>
            <div class="section-content">12、可以补充货款差价的方式升级为高级合伙人，升级后除已提货商品，享受高级合伙人相应政策。</div>
            <div class="section-title">二、补货政策</div>
            <div class="section-content">1、补货数量政策如下: <br>
                ① 御粮春生、御粮夏长进货数量需为5箱的倍数 <br>
                ② 御粮秋实、御粮冬藏进货数量需为大于或等于1箱的整数
            </div>
            <div class="section-content">
                2、补货仍可享受同品类商品的优惠政策如下: <br>
                ① 御粮春生、御粮夏长进货满5*n箱赠送3*n箱奖励2*n箱(n为整数)<br>
                ② 御粮秋实、御粮冬藏每进货n箱赠送n箱.<br>
                (以此类推,上不封顶)
            </div>
            <div class="section-content">2、补货仍可享受每满5箱赠送3箱奖励2箱的优惠（以此类推，上不封顶）；</div>
            <div class="section-content">3、赠送商品随购买商品一同发放，奖励商品在补货商品销售完毕再次补货时发放至奖励账户。</div>
            <div class="section-title">三、退/换货政策</div>
            <div class="section-content">1、商品上市之日起前108名合伙人（以《合伙人合作协议》协议编号为准）可享特别退货政策。即一年内首次购入的18万元/4.2万元商品未销售完毕，可于满一年之日起30日内申请剩余整箱存货全额退货，退货单价及金额按照如下规则计算：</div>
            <div class="section-content">（1）已进货的，退货单价=全部已进货商品总金额/全部已进货商品（含购买商品和赠送商品）数量，退货金额=退货数量*退货单价；</div>
            <div class="section-content">（2）未进货的 ，按照货款账户余额全额退款。但合伙人再次购买商品的，不论首次购入商品是否销售完毕，均不可申请退货。</div>
            <div class="section-content">2、满一年之日起30日后申请退货的，公司有权不予退货。</div>
            <div class="section-content">3、非前108名合伙人，售出商品（含已购买未提货商品）非因质量问题一律不予退换。</div>
        </div>
        <div class="section" v-if="role == 'partner' && userInfo.level == 3">
            <div class="section-title">一、高级合伙人政策</div>
            <div class="section-content">1、加入门槛：一次性订货不低于18万元的商品；</div>
            <div class="section-content">2、可享受高级合伙人级别进货价；</div>
            <div class="section-content">
                3、可享受进货同品类商品的优惠政策如下: <br>
                ① 御粮春生、御粮夏长进货满5*n箱赠送3*n箱奖励2*n箱(n为整数)<br>
                ② 御粮秋实、御粮冬藏每进货n箱赠送n箱.<br>
                (以此类推,上不封顶)
            </div>
            <div class="section-content">4、每次进货订单中的赠送商品随进货商品一同发放，该订单中的奖励商品在下次补货时(即下次补款时)发放至销售奖励账户；</div>
            <div class="section-content">5、订货的商品可分批次进货，每次进货数量须为5箱或5箱的倍数；奖励商品可分批次提货；</div>
            <div class="section-content">6、可任品类搭配商品，但需满足同品类5箱或5箱的倍数进货；</div>
            <div class="section-content">7、无需交纳保证金；</div>
            <div class="section-content">8、不可低于公司线下最低指导价进行销售，乱价合伙人不享受公司额外奖励的商品；</div>
            <div class="section-content">9、可不定期参加公司组织的销售培训；</div>
            <div class="section-content">10、公司为合伙人开展线下商品品鉴活动提供津贴支持。品鉴活动参加人数原则上不得低于20人/场，每位合伙人每月仅可申请一次津贴支持。公司对满足条件的品鉴活动提供如下支持：</div>
            <div class="section-content">（1）组织活动的合伙人可向公司申请津贴，津贴标准为120元/人。申请批准后，津贴将于品鉴活动结束的次月10日前发放至合伙人推荐奖账户（合伙人推荐奖账户定义、使用方法参见公司另行制定的《合伙人账户使用说明》）；</div>
            <div class="section-content">（2）公司免费提供御粮春生酒供参会人员品鉴，提供标准为：每10人提供2瓶；</div>
            <div class="section-content">（3）公司将派遣工作人员前往品鉴活动现场配合合伙人进行御粮产品宣讲与推广；</div>
            <div class="section-content">11、年终按照总销售额排名享受公司各项奖励；</div>
            <div class="section-content">12、推荐十名及以上高级合伙人可升级成为战略合伙人；</div>
            <div class="section-content">13、战略合伙人可享受团队管理津贴；</div>
            <div class="section-content">14、战略合伙人可享受公司股权激励。</div>
            <div class="section-title">二、补货政策</div>
            <div class="section-content">1、补货数量政策如下: <br>
                ① 御粮春生、御粮夏长进货数量需为5箱的倍数 <br>
                ② 御粮秋实、御粮冬藏进货数量需为大于或等于1箱的整数
            </div>
            <div class="section-content">
                2、补货仍可享受同品类商品的优惠政策如下: <br>
                ① 御粮春生、御粮夏长进货满5*n箱赠送3*n箱奖励2*n箱(n为整数)<br>
                ② 御粮秋实、御粮冬藏每进货n箱赠送n箱.<br>
                (以此类推,上不封顶)
            </div>
            <div class="section-content">3、赠送商品随购买商品一同发放，奖励商品在补货商品销售完毕再次补货时发放至奖励账户。</div>
            <div class="section-title">三、退/换货政策</div>
            <div class="section-content">1、商品上市之日起前108名合伙人（以《合伙人合作协议》协议编号为准）可享特别退货政策。即一年内首次购入的18万元/4.2万元商品未销售完毕，可于满一年之日起30日内申请剩余整箱存货全额退货，退货单价及金额按照如下规则计算：</div>
            <div class="section-content">（1）已进货的，退货单价=全部已进货商品总金额/全部已进货商品（含购买商品和赠送商品）数量，退货金额=退货数量*退货单价；</div>
            <div class="section-content">（2）未进货的 ，按照货款账户余额全额退款。但合伙人再次购买商品的，不论首次购入商品是否销售完毕，均不可申请退货。</div>
            <div class="section-content">2、满一年之日起30日后申请退货的，公司有权不予退货。</div>
            <div class="section-content">3、非前108名合伙人，售出商品（含已购买未提货商品）非因质量问题一律不予退换。</div>
        </div>
        <div class="section" v-if="role == 'reward'">
            <div class="section-title">推荐合伙人奖励机制</div>
            <div class="section-content">1、御粮高级合伙人推荐新合伙人加入，可享受被推荐人首次订货金额的10%、补货金额的5%作为奖励；</div>
            <div class="section-content">2、御粮初级合伙人推荐新合伙人加入，可享受被推荐人首次订货金额的6%、补货金额的3%作为奖励；</div>
            <div class="section-content">3、推荐人奖励在被推荐人满足以下任一条件时计算并发放至推荐奖账户：</div>
            <div class="section-content">（1）被推荐人为前108名合伙人的：</div>
            <div class="section-content">① 被推荐人完成首次订货商品的销售或者补货的，以该批次订货总价款依照本条第1款、第2款约定的比例计算奖励金额；并同时发放至推荐奖励账户.</div>
            <div class="section-content">② 被推荐人存在退货情形，且退货数量经公司确认后，按已销售商品对应的订货金额及本条第1款、第2款约定的比例计算奖励金额；并同时发放至推荐奖励账户.</div>
            <div class="section-content">③ 被推荐人补货货款到账，以该批次补货总价款依照本条第1款、第2款约定的比例计算奖励金额,并在下次补货货款到账时,发放至推荐奖励账户.</div>
            <div class="section-content">（2）被推荐人非前108名合伙人的：</div>
            <div class="section-content">被推荐人订货或补货货款到账，以该批次订货或补货总价款依照本条第1款、第2款约定的比例计算奖励金额,,并在下次补货货款到账时,发放至推荐奖励账户.</div>
            <div class="section-content">4、推荐奖账户奖励金额不可提现，可按照各级别合伙人进货价购买商品，但不可享受每满5箱赠送3箱奖励2箱的优惠；</div>
            <div class="section-content">5、新合伙人再次邀请新人加入与原推荐人无关。</div>
        </div>
    </div>
</template>
<script>
import $http from '@/lib/request'
import config from '@/config'
import { setLocalUserInfo } from '@/lib/util'

export default {
    data(){
        return {
            role:'',//reward 推荐合伙人奖励 ,partner 合伙人
            userInfo:{},
        }
    },
    activated(){
        this.role=this.$route.query.role;
        this.checkuData();
    },
    methods:{
        checkuData(){//获取最新用户信息
            $http({
                method:'post',
                url:config.api.checkUserData
            }).then(res=>{
                if(res.errno == 0){
                    this.userInfo=res.data;
                    setLocalUserInfo(res.data);
                }else{
                    Toast(res.errmsg)
                }
            })
        },
    }
}
</script>
<style lang="scss" scoped>
    .page-container{
        min-height:100vh;
        box-sizing: border-box;
        background:#fff;
        padding:30px 20px;
        .section{
            margin-bottom: 20px;
            .section-title{
                margin: 15px 0;
                font-size: 18px;
                color:#333;
                line-height: 24px;
                font-weight: 500;
            }
            .section-content{
                font-size: 14px;
                color:#333;
                line-height: 20px;
                margin-bottom: 10px;
                &:last-child{
                    margin-bottom: 0;
                }
            }
        }
    }
</style>